export const CREATE = "orders.newnotification.CREATE";
export const CREATE_FAILED = "orders.newnotification.CREATE_FAILED";
export const CREATE_OK = "orders.newnotification.CREATED";

export const SET_FIELDS = "orders.newnotification.SET_FIELDS";
